import { SvgIcon } from '@mui/material';
import React from 'react';

function PaymentsIcon(props) {
  return (
    <SvgIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 3H2V12H14V3ZM8 9.75C9.24265 9.75 10.25 8.74265 10.25 7.5C10.25 6.25735 9.24265 5.25 8 5.25C6.75735 5.25 5.75 6.25735 5.75 7.5C5.75 8.74265 6.75735 9.75 8 9.75Z"
        fill="black"
      />
      <path d="M15.5 5.25H17V15H4.25V13.5H15.5V5.25Z" fill="black" />
    </SvgIcon>
  );
}

export default PaymentsIcon;
